import React, { Component } from "react";
import _ from "lodash";

import TagList from "./TagList";
import ManageModal from "./ManageModal";
import ConfirmModal from "../../components/Modals/Confirm";

import TagsAPI from "../../api/tags";

class Tags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      tag: "",
      selectedTagID: "",
      showModal: false,
      showConfirmModal: false
    };
  }

  componentDidMount() {
    this.getTags();
  }

  selectTag = id => {
    const { tags } = this.state;
    const tag = _.find(tags, t => t.tag_id === id);

    this.setState({
      selectedTagID: tag.tag_id,
      tag: tag.tag_name,
      showModal: true
    });
  };

  onChange = e => {
    this.setState({ tag: e.target.value });
  };

  getTags = () => {
    TagsAPI.getTags().then(tags => this.setState({ tags: tags.data }));
  };

  onSubmit = e => {
    e.preventDefault();
    const { tag, selectedTagID } = this.state;
    const formData = {
      tag,
      id: selectedTagID
    };

    TagsAPI.manageTag(formData).then(() => {
      this.toggleManageModal();
      this.getTags();
    });
  };

  toggleManageModal = () => {
    const { showModal } = this.state;
    if (showModal) {
      this.setState({
        tag: "",
        selectedTagID: ""
      });
    }

    this.setState({ showModal: !showModal });
  };

  toggleConfirmModal = () => {
    const { showConfirmModal } = this.state;
    this.setState({ showConfirmModal: !showConfirmModal });
  };

  deleteTag = () => {
    const { selectedTagID } = this.state;
    TagsAPI.deleteTag(selectedTagID).then(() => {
      this.toggleConfirmModal();
      this.toggleManageModal();
      this.getTags();
    });
  };

  render() {
    const { tags, tag, showModal, showConfirmModal } = this.state;
    return (
      <div>
        <ConfirmModal
          show={showConfirmModal}
          title="Confirm Delete"
          toggle={this.toggleConfirmModal}
          confirm={this.deleteTag}
        >
          Are you sure you want to delete this tag?
        </ConfirmModal>

        <ManageModal
          tag={tag}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          show={showModal}
          onHide={this.toggleManageModal}
          onDelete={this.toggleConfirmModal}
        />

        <button className="btn btn-primary" onClick={this.toggleManageModal}>
          <i className="fa fa-plus-circle" /> Add Tag
        </button>

        <hr />

        <div className="row">
          <div className="col-md-12">
            <TagList tags={tags} onClick={this.selectTag} />
          </div>
        </div>
      </div>
    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/pages/Tags/index.jsx